import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import { Mascot } from "@/components/Mascot";
import PinLogin from "@/pages/PinLogin";
import HomePage from "@/pages/Home";
import Duitku from "@/pages/Duitku";
import MoodAku from "@/pages/MoodAku";
import BacaYuk from "@/pages/BacaYuk";
import SettingsPage from "@/pages/Settings";

const Gate = () => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen grid place-items-center bg-pink-50">
        <Mascot pose="wave" className="w-28" />
      </div>
    );
  if (!user) return <PinLogin />;
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/duitku" element={<Duitku />} />
          <Route path="/mood" element={<MoodAku />} />
          <Route path="/baca" element={<BacaYuk />} />
          <Route path="/pengaturan" element={<SettingsPage />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Gate />
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
